/**
 * SMSTemplatesView - Template management interface
 */
import { Plus, FileText, Edit2, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function SMSTemplatesView({
  templates,
  onOpenTemplateDialog,
  onDeleteTemplate,
  onApplyTemplate,
  onSwitchToCompose
}) {
  return (
    <div className="bg-card rounded-2xl p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="font-medium text-foreground">SMS Templates</h3>
        <Button onClick={() => onOpenTemplateDialog(null)}>
          <Plus className="w-4 h-4 mr-2" />
          New Template
        </Button>
      </div>

      {templates.length === 0 ? (
        <div className="text-center py-12">
          <FileText className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground">No templates created yet</p>
          <Button
            variant="outline"
            className="mt-4"
            onClick={() => onOpenTemplateDialog(null)}
          >
            Create Your First Template
          </Button>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {templates.map(template => (
            <div key={template.id} className="border border-border rounded-xl p-4 bg-background">
              <div className="flex items-start justify-between mb-2">
                <h4 className="font-medium text-foreground">{template.name}</h4>
                <div className="flex gap-1">
                  <button
                    onClick={() => onOpenTemplateDialog(template)}
                    className="p-1 hover:bg-muted rounded"
                  >
                    <Edit2 className="w-4 h-4 text-muted-foreground" />
                  </button>
                  <button
                    onClick={() => onDeleteTemplate(template.id)}
                    className="p-1 hover:bg-destructive/10 rounded"
                  >
                    <Trash2 className="w-4 h-4 text-destructive" />
                  </button>
                </div>
              </div>
              <p className="text-sm text-muted-foreground line-clamp-3 mb-3">
                {template.content}
              </p>
              <div className="flex items-center justify-between text-xs text-muted-foreground">
                <span className="bg-muted px-2 py-1 rounded">{template.category}</span>
                <span>Used {template.usage_count || 0} times</span>
              </div>
              <Button
                variant="outline"
                size="sm"
                className="w-full mt-3"
                onClick={() => {
                  onApplyTemplate(template);
                  onSwitchToCompose();
                }}
              >
                Use Template
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
